/* eslint-disable no-multi-assign */
import $ from 'jquery'

declare const window: any

window.jQuery = window.$ = $
